export default __webpack_public_path__ + "static/media/Animals07.0bf58d66.jpg";